import { gql } from '@apollo/client';

export const RdExpenseProjectAllocationFragment = gql`
  fragment RdExpenseProjectAllocation on RdExpenseProjectAllocation {
    id
    rdProjectId
    allocationPercentNotRounded
    projectName
    project {
      id
      name
      consideredForRd
      isSection174Eligible
    }
  }
`;
